import * as React from 'react';
import classNames from 'classnames';
import './pageSection.module.scss';

type Props = {
    id?: string;
    title: string;
    subTitle: string;
    background?: 'mint-green' | 'gray' | 'white';
    className?: string;
    styleName?: string;
    children?: any;
};

export const PageSection = ({ id, title, subTitle, background = 'white', className, children }: Props) => (
    <div styleName={classNames('section-wrapper', background)} id={id}>
        <div styleName="section" className={className}>
            <div styleName="header">
                <div styleName="title">{title}</div>
                <div styleName="sub-title">{subTitle}</div>
            </div>
            <div styleName="body">{children}</div>
        </div>
    </div>
);
